import { useQuery } from '@apollo/client';
import GET_POTENTIAL_DAMAGE_ATTRS from 'queries/GetPotentialDamageAttributes.gql';
import { AtlasGqlPotentialDamageAttributes } from 'types/atlas-graphql';

interface Props {
  pictureId?: string;
  coordinates?: number[];
  attrs?: Record<string, any>;
}

export function usePotentialDamageAttrs({ pictureId, coordinates, attrs }: Props) {
  const { data, loading } = useQuery(GET_POTENTIAL_DAMAGE_ATTRS, {
    variables: { pictureId, coordinates, attrs },
    skip: !pictureId || !coordinates || coordinates.length < 4,
  });
  const {
    // generic attributes
    inspectionDate,
    length,
    width,
    assetIds,

    // blade attributes
    radialDistance,
    bladeSide,
    bladeChamber,
    chordAverage,
    chordPoints,

    // tower/tp attributes
    distanceFromNacelleCenter,
    towerSide,
    transitionPieceSide,

    // nacelle attributes
    nacelleSide,
  } = (data?.getPotentialDamageAttributes ?? {}) as AtlasGqlPotentialDamageAttributes;

  const potentialAttrs = {
    // generic attributes
    Date: inspectionDate,
    Length: length,
    Width: width,
    'Asset Ids': assetIds,

    // blade attributes
    Distance: radialDistance,
    'Blade Side': bladeSide,
    'Blade Chamber': bladeChamber,
    Chord: chordAverage,
    'Chord Points': chordPoints ? JSON.stringify(chordPoints) : chordPoints,

    // tower/tp attributes
    'Distance from Nacelle': distanceFromNacelleCenter,
    'Tower Side': towerSide,
    'Transition Piece Side': transitionPieceSide,

    // nacelle attributes
    'Nacelle Side': nacelleSide,
  };

  return { loading, potentialAttrs };
}
